import React from "react";
import { Progress, Tag } from "antd";
import { calculateDueProgress } from "../../utils/progress";
import { formatDate, getKolkataUnixSeconds } from "../../utils/date";

const DueProgress = ({ dueDate, assignEpoch }) => {
  const currentTime = getKolkataUnixSeconds();
  const { percentage, color, overdue } = calculateDueProgress(
    dueDate,
    assignEpoch,
    currentTime
  );

  if (!dueDate) {
    return <span className="due-date-empty">-</span>;
  }

  return (
    <div className="due-progress-cell">
      <span className="due-date-badge">{formatDate(dueDate)}</span>
      {overdue && (
        <Tag color="error" className="overdue-tag">
          Overdue
        </Tag>
      )}
      {assignEpoch && (
        <div className="progress-block">
          <Progress
            percent={percentage}
            size="small"
            strokeColor={color}
            format={(percent) => `${percent?.toFixed(1)}%`}
            status={overdue ? "exception" : "active"}
          />
          <span className="progress-label">Due progress</span>
        </div>
      )}
    </div>
  );
};

export default DueProgress;
